import {
  IPublicClientApplication,
  PublicClientApplication,
  InteractionType,
  BrowserCacheLocation,
} from "@azure/msal-browser";
import {
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG,
  MsalService,
  MsalGuard,
  MsalBroadcastService,
  MsalInterceptor,
  MsalInterceptorConfiguration,
  MsalGuardConfiguration,
} from "@azure/msal-angular";
import { inject } from "@angular/core";
import { ConfigService } from "../services/config";
import { HTTP_INTERCEPTORS } from "@angular/common/http";

export function msalInstanceFactory(): IPublicClientApplication {
  const config = inject(ConfigService);
  const msalInstance = new PublicClientApplication({
    auth: {
      clientId: config.get("CLIENT_ID"),
      authority: `https://login.microsoftonline.com/${config.get("TENANT_ID")}`,
      redirectUri: config.get("REDIRECT_URI"),
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
  });

  // Ensure instance is initialized before returning
  msalInstance.initialize().catch((error) => {
    console.error("MSAL Initialization Error:", error);
  });

  return msalInstance;
}

export function msalGuardConfigFactory(): MsalGuardConfiguration {
  const config = inject(ConfigService);

  return {
    interactionType: InteractionType.Redirect,
    authRequest: { scopes: config.get("SCOPE_URI") },
  };
}

export function msalInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const config = inject(ConfigService);
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map([
      ["https://graph.microsoft.com/v1.0/me", ["user.read"]],
      [config.get("BACKEND_URI"), config.get("SCOPE_URI")],
    ]),
  };
}

export const MSAL_PROVIDERS = [
  { provide: MSAL_INSTANCE, useFactory: msalInstanceFactory },
  { provide: MSAL_GUARD_CONFIG, useFactory: msalGuardConfigFactory },
  {
    provide: MSAL_INTERCEPTOR_CONFIG,
    useFactory: msalInterceptorConfigFactory,
  },
  { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
  MsalService,
  MsalGuard,
  MsalBroadcastService,
];
